import React from 'react';
import ColumnaBotoneraItem from '../ColumnaBotoneraItem.js';
import styles from '../CuadroListaEditable.module.css';
import styleCols from './TablaBoletines.module.css';
import { FechaCorta } from '../../funciones/FuncionesFecha.js';

const TablaBoletines = (props) => {
  const lista = props.lista || [];
  const idElegido = props.idElegido;
  const onEditarItem = props.onEditarItem;
  const onEliminarItem = props.onEliminarItem;

  const esIdElegido = (idItem) => {
    return Number(idElegido) === Number(idItem);
  };

  return (
    <React.Fragment>
      <tr key="0" className={`${styles.titulos}`}>
        <td className={`${styleCols.boletin}`}>Boletín</td>
        <td className={`${styleCols.tipoPase}`}>Tipo Pase</td>
        <td className={`${styleCols.hasta}`}>Hasta</td>
        <td className={`${styleCols.origen}`}>Origen</td>
        <td className={`${styleCols.destino}`}>Destino</td>
        <td></td>
      </tr>
      {lista.map((item) => (
        <tr className={`${styles.valores} ${esIdElegido(item.id) && styles.elegido}`} key={item.id}>
          <td className={`${styleCols.boletin}`}>
            {item.boletin && item.boletin.codigoBoletinJugadores}
          </td>
          <td className={`${styleCols.tipoPase}`}>
            {item.tipoPaseBoletin && item.tipoPaseBoletin.descripcion}
          </td>
          <td className={`${styleCols.hasta}`}>{FechaCorta(item.fechaHasta)}</td>
          <td className={`${styleCols.origen}`}>{item.origen && item.origen.nombre}</td>
          <td className={`${styleCols.destino}`}>{item.destino && item.destino.nombre}</td>
          <ColumnaBotoneraItem
            idItem={item.id}
            onEditarItem={onEditarItem}
            onEliminarItem={onEliminarItem}
          />
        </tr>
      ))}
    </React.Fragment>
  );
};

export default TablaBoletines;
